<script>
    // @check-js
    import { getVariantPrice, formatCurrency, getTotalCartPrice } from "../../utils/price.js";
    import { generateProductSizeString, getImageUrl, getStockText } from "../../utils/cart-listing.utils.js";

    import FullHr from "../FullHr.svelte";
    import Spacer from "../Spacer.svelte";

    /**
     * @typedef {import("../../routes/server-api/product/types").ProductResponse & {artnr: string}} CartProductResponse
     */
    /** @type {CartProductResponse[]} */
    export let products;
    export let onNumChange = () => {};
    export let close = () => {};

    const numRange = new Array(30).fill(1).map((_, i) => i);
</script>

{#if products && products.length}
    <div class="products-wrapper">
        {#each products as product (product.artnr)}
            <FullHr />
            <div class="flex flex-row product-row">
                <div class="w-1/6 px-4 shrink-0 grow-0">
                    <img class="product-image" src={getImageUrl(product)} alt="" />
                </div>
                <div class="col-product-name w-full">
                    <h5 class="product-link">
                        <a on:click={close} href={product.canonical}>{product.name}</a>
                    </h5>
                    {#if product.colors.length}
                        <p>Färg: {product.colors[0].name}</p>
                    {/if}
                    {#if product.scallops.length}
                        <p>Sydd kant: {product.scallops[0].name}</p>
                    {/if}
                    {#if product.slides.length}
                        <p>Plastskenor: {product.slides[0].name}</p>
                    {/if}
                    {#if product.sizes.length || product.sample}
                        <p>Storlek: {generateProductSizeString(product)}</p>
                    {/if}
                </div>
                <div class="w-1/4 num-price right-text pl-0 px-4 flex flex-col justify-around">
                    <div class="w-full pl-0 px-4 py-2">
                        <!-- svelte-ignore a11y-no-onchange -->
                        <select
                            class="border border-gray-500 rounded-sm"
                            value={product.num}
                            on:change={(e) => onNumChange(product.artnr, product.sample, e.target.value)}
                            aria-label="Antal av denna produkt"
                        >
                            {#each numRange as num}
                                <option value={num} selected={num === product.num}>
                                    {num}
                                </option>
                            {/each}
                        </select>
                    </div>
                    <Spacer />
                    <Spacer />
                    <div class="w-full pl-0 product-price px-4 whitespace-nowrap">
                        {formatCurrency(getVariantPrice(product) * product.num)}
                    </div>
                </div>
            </div>
            {#if product.colors[0].sizes[0].stock && !product.colors[0].sizes[0].stock.inStock && product.colors[0].sizes[0].stock.backInStock}
                <div class="text-xs text-red-700 italic whitespace-nowrap -mt-1 px-4 mb-3">
                    OBS: {getStockText(product.colors[0].sizes[0])}
                </div>
            {/if}
        {/each}
        <FullHr />
    </div>
    <FullHr />
    <div class="flex flex-wrap justify-between text-lg py-2">
        <div class="col">SUMMA PRODUKTER</div>
        <div class="right-text px-4">
            {formatCurrency(getTotalCartPrice(products))}
        </div>
    </div>
    <hr />
{:else}
    <h3>Du har inga produkter i kundvagnen</h3>
{/if}

<style>
    .products-wrapper {
        max-height: 250px;
        overflow-x: hidden;
        overflow-y: auto;
        background: #fafafa;
        box-shadow: inset 0 0 0.2em rgba(0, 0, 0, 0.35);
    }
    .product-row {
        padding: 4px;
        vertical-align: middle;
        align-items: center;
    }
    .col-product-name {
        padding: 0 10px;
    }
    .product-link {
        cursor: pointer;
    }
    .col-product-name h5 {
        font-size: 1.2em;
    }
    .col-product-name > * {
        margin-bottom: 0;
    }
    .right-text {
        text-align: right;
    }
    .product-image {
        width: 100%;
        height: auto;
        max-width: 50px;
        max-height: 70px;
    }
    .num-price > * {
        white-space: nowrap;
    }
    .product-price {
        font-size: 0.95rem;
    }
</style>
